import { Injectable } from '@angular/core';

declare var $: any;

@Injectable()
export class VMsg_ko_KR {
static load() {

/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: KO (Korean; 한국어)
 */
$.extend( $.validator.messages, {
	required: "필수 항목입니다.",
	remote: "항목을 수정하세요.",
	email: "유효하지 않은 E-Mail주소입니다.",
	url: "유효하지 않은 URL입니다.",
	date: "올바른 날짜를 입력하세요.",
	dateISO: "올바른 날짜(ISO)를 입력하세요.",
	number: "유효한 숫자가 아닙니다.",
	digits: "숫자만 입력 가능합니다.",
	creditcard: "신용카드 번호가 바르지 않습니다.",
	equalTo: "같은 값을 다시 입력하세요.",
	extension: "올바른 확장자가 아닙니다.",
	maxlength: $.validator.format( "{0}자를 넘을 수 없습니다. " ),
	minlength: $.validator.format( "{0}자 이상 입력하세요." ),
	rangelength: $.validator.format( "문자 길이가 {0} 에서 {1} 사이의 값을 입력하세요." ),
	range: $.validator.format( "{0} 에서 {1} 사이의 값을 입력하세요." ),
	max: $.validator.format( "{0} 이하의 값을 입력하세요." ),
	min: $.validator.format( "{0} 이상의 값을 입력하세요." ),
	step: $.validator.format( "{0}의 배수를 입력하십시오." ),
	accept: "유효한 확장자로 값을 입력하십시오.",
	alphanumeric: "문자, 숫자 및 밑줄 만 입력하십시오.",
	integer: "양수 또는 음수의 10 진수가 아닌 값을 입력하십시오.",
	ipv4: "올바른 IPv4 주소를 입력하십시오.",
	ipv6: "올바른 IPv6 주소를 입력하십시오.",
	lettersonly: "문자 만 입력하십시오.",
	letterswithbasicpunc: "글자 나 문장 부호 만 입력하십시오.",
	notEqualTo: "다른 값을 입력하십시오. 값은 동일하지 않아야합니다.",
	nowhitespace: "공백을 입력하지 마십시오.",
	pattern: $.validator.format( "형식이 잘못되었습니다 ({0})." ),
	time: "유효한 시간을 00:00에서 23:59 사이에 입력하십시오.",
	url2: "유효하지 않은 URL입니다.",
	minbytelength: $.validator.format( "{0} 바이트 이상으로 입력하십시오." ),
	maxByteLength: $.validator.format( "{0} 바이트 이내로 입력하십시오." ),
	rangeByteLength: $.validator.format( "{0} 바이트에서 {1} 바이트까지의 문자를 입력하십시오." ),
	halfWidth: "영문 만 입력하십시오.",
	fullWidth: "한글 만 입력하십시오.",
	kanji: "한자 만 입력하십시오.",
	kana: "가명 만 입력하십시오.",
	hiragana: "히라가나 만 입력하십시오.",
	katakana: "가타카나 만 입력하십시오.",
	halfKatakana: "반각 가타카나 만 입력하십시오.",
	fullKatakana: "전각 가타카나 만 입력하십시오.",
	date_yyyyMMdd: "유효한 날짜를 입력하십시오 (yyyyMMdd).",
	date_yyyy_MM_dd: "유효한 날짜를 입력하십시오 (yyyy/MM/dd).",
	date_yyyy_MM: "유효한 날짜를 입력하십시오 (yyyy/MM).",
	date_yyyyMM: "유효한 날짜를 입력하십시오 (yyyyMM).",
	date_MM_dd: "유효한 날짜를 입력하십시오 (MM/dd).",
	date_MMdd: "유효한 날짜를 입력하십시오 (MMdd).",
	time_HH_mm: "유효한 시간을 입력하십시오 (HH:mm).",
	time_HH_mm_ss: "유효한 시간을 입력하십시오 (HH:mm:ss).",
	time_HHmmss: "유효한 시간을 입력하십시오 (HHmmss).",
	phoneJP: "유효한 전화 번호를 입력하십시오.",
	mobileJP: "유효한 휴대폰 번호를 입력하십시오.",
	numberLessThen: "더 적은 번호를 입력하십시오.",
	numberLessEqualTo: "같은 번호 이하를 입력하십시오.",
	dateLessThen: "이전 시간을 지정하십시오.",
	dateLessEqualTo: "이전 또는 이전 시간을 지정하십시오.",
	pwd: "숫자, 문자 또는 표[@#$%]가 필요합니다."
} );
}
}


// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/resources/validate_ko-KR.ts